module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-drawer"
  }, [_c('div', {
    staticClass: "main",
    style: ({
      'transform': 'translate3d(' + _vm.translateX + 'px,0,0)'
    })
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "mask",
    class: _vm.show ? 'active' : '',
    style: ({
      position: !_vm.show ? 'relative' : 'fixed'
    }),
    on: {
      "click": _vm.hideMask
    }
  })], 2), _vm._v(" "), _c('div', {
    ref: "drawer",
    staticClass: "drawer",
    class: [_vm.pos != 'left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'active' : ''],
    style: ({
      position: !_vm.show ? 'relative' : 'fixed'
    })
  }, [_vm._t("drawer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4bf72d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ui/drawer.vue
// module id = 1358
// module chunks = 1